import { Component, OnInit } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";

@Component({
  selector: "app-cars-app",
  templateUrl: "./cars-app.component.html",
  styleUrls: ["./cars-app.component.css"],
})
export class CarsAppComponent implements OnInit {
  title = "برنامج ادارة شركات ايجار السيارات متكامل ";
  Section1content: string[] = [
    "Add vehicles with all their details, brands, class, or color, as well as the monthly and daily rental value",
    "Add fuel rates",
    "Add oil change rates to alert the company of car oil change times",
    "Alert of the vehicle license renewal date",
  ];
  Section2content: string[] = [
    "View car revenues, expenses and maintenance costs",
    "Add car features to be displayed on the rental platform, such as the number of doors and multiple car options",
    "Add files for each car",
    "View all car contracts and the ability to control them",
  ];
  Section3content: string[] = [
    "Adding a violation to a specific car",
    "Determine the paid and unpaid violations and their value",
    "Report the highest violations that have not been paid and link them to contracts",
  ];
  Section4content: string[] = [
    "Connecting each vehicle with all its types of maintenance as well as its schedules",
    "Remind the administration of the maintenance dates for each car and alert several days in advance",
    "Add car repair garages to easily connect the car to it",
    "Comprehensive reports on the types and costs of maintenance, as well as the most well-maintained cars in the company",
  ];
  Section5content: string[] = [
    "Managing vehicle contracts of all kinds (management - maintenance - rental - companies)",
    "Smooth selection of the customer, employee or company from the database",
    "Choose the vehicle to be rented and complete its data automatically",
    "The ability to print the contract in full and in detail",
    "Determine the type of contracts, monthly or daily",
    "Upload photos of the vehicle before leaving and upon returning to see its condition",
    "The possibility of calculating the contract and it is done automatically",
  ];
  Section6content: string[] = [
    "The possibility of adding a discount in the contract",
    "Create receipt and exchange vouchers for each contract",
    "Creation of extension bonds in case the car is not returned on time",
  ];

  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    this.metaService.addTag({
      name: "description",
      content:
        "شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفضل الله باستخدام احدث اللغات والتقنيات في تصميم المواقع والتطبيقات",
    });
    this.metaService.addTag({
      name: "og:description",
      content:
        "شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفضل الله باستخدام احدث اللغات والتقنيات في تصميم المواقع والتطبيقات",
    });
    this.metaService.addTag({
      name: "twitter:description",
      content:
        "شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفضل الله باستخدام احدث اللغات والتقنيات في تصميم المواقع والتطبيقات",
    });
    this.metaService.addTag({
      name: "keywords",
      content:
        "تصميم برامج ادارة السيارات,برنامج شركات ادارة تاجير السيارات,تاجير السيارات",
    });

    this.titleService.setTitle(this.title);
  }
}
